<div class="dl-modelnode-hovergroep"
     [class.dl-modelnode-hovergroep--voorgrond]="naarVoren()"
     [class.dl-modelnode-hovergroep--ballon]="heeftOpenBallon()"
     [class.dl-modelnode-hovergroep--uitleg]="uitlegZichtbaar()"
     [dlNodeVolger]="node"
     [cy]="cy"
     ankertype="bbox"
     [volgFormaat]="true"
     [schaalMetZoom]="false"
     [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar">
    <div class="dl-modelnode-hovergroep__topicons">
        <dl-simfeedback
            [node]="node" [cy]="cy"
            [aan]="modelcanvas.isSimfeedbackAan()"
            [meldingen]="modelcanvas.getSimfeedbackVoorNode(node)"
            (subHover)="opSimfeedbackHover($event)"></dl-simfeedback>
        <dl-normfeedback
            [node]="node" [cy]="cy"
            [aan]="modelcanvas.isNormfeedbackAan()"
            [meldingen]="modelcanvas.getNormfeedbackVoorNode(node)"
            (subHover)="opNormfeedbackHover($event)"></dl-normfeedback>
        <dl-bouwsuggestie
            [node]="node" [cy]="cy"
            [noodzakelijkAan]="modelcanvas.isBouwsuggestieNoodzakelijkAan()"
            [gewenstAan]="modelcanvas.isBouwsuggestieGewenstAan()"
            [projectOndersteuntNoodzakelijk]="modelcanvas.projectOndersteuntBouwsuggestieNoodzakelijk()"
            (subHover)="opBouwsuggestieHover($event)"></dl-bouwsuggestie>
    </div>
    <div class="dl-modelnode-hovergroep__uitleg-slot"
         [class.dl-modelnode-hovergroep__uitleg-slot--rechts]="uitlegNaarRechts">
        <dl-node-dom-uitleg
            [nodetype]="nodetype"
            [modelleerniveau]="modelleerniveau"
            [zichtbaar]="uitlegZichtbaar()"
            (uitlegActie)="opUitlegActie($event)"></dl-node-dom-uitleg>
    </div>
</div>
